import { ReactNode } from 'react';

interface StepProgressProps {
  step: number;
  total?: number;
  brandColor: string;
  label: string;
  lastStepLabel?: ReactNode; // caption shown above the final segment
}

export function StepProgress({ step, total = 3, brandColor, label, lastStepLabel }: StepProgressProps) {
  return (
    <div className="flex items-center gap-3">
      <div className="flex flex-1 gap-1.5">
        {Array.from({ length: total }, (_, i) => i + 1).map((n) => {
          const filled = n <= step;
          return (
            <div key={n} className="relative flex-1">
              {n === total && lastStepLabel && (
                <span className="absolute bottom-full left-1/2 mb-1 -translate-x-1/2 whitespace-nowrap text-[10px] font-bold uppercase tracking-wide text-[#8a8f98]">
                  {lastStepLabel}
                </span>
              )}
              <div
                data-filled={filled}
                className="h-1 rounded-sm"
                style={{ background: filled ? brandColor : '#e6e7ea' }}
              />
            </div>
          );
        })}
      </div>
      <span className="whitespace-nowrap text-xs font-bold tracking-wide text-[#8a8f98]">
        {label}
      </span>
    </div>
  );
}
